module.exports = __webpack_public_path__ + "static/media/mail-icon.9f0b284f.svg";